import { title } from "process";
import React from "react";
import { useTranslation } from "react-i18next";

const Solutions = () => {
  const { t } = useTranslation();

  const items = [
    {
      icon: "/assets/images/vecteurs/code-tech-dev-svgrepo-com.svg",
      title: t("about.solutions.titreCard1"),
      description: t("about.solutions.paraphCard1"),
      bgColor: "bg-[#DBEAFF]",
      bgIcon: "bg-blue-primary",
    },

    {
      icon: "/assets/images/vecteurs/object.svg",
      title: t("about.solutions.titreCard2"),
      description: t("about.solutions.paraphCard2"),
      bgColor: "bg-[#DBEAFF]",
      bgIcon: "bg-blue-primary",
    },

    {
      icon: "/assets/images/vecteurs/data-svgrepo-com.svg",
      title: t("about.solutions.titreCard3"),
      description: t("about.solutions.paraphCard3"),
      bgColor: "bg-[#DBEAFF]",
      bgIcon: "bg-blue-primary",
    },

    {
      icon: "/assets/images/vecteurs/heart-pulse-2-svgrepo-com.svg",
      title: t("about.solutions.titreCard4"),
      description: t("about.solutions.paraphCard4"),
      bgColor: "bg-[#DBEAFF]",
      bgIcon: "bg-blue-primary",
    },

    {
      icon: "/assets/images/vecteurs/documents-svgrepo-com.svg",
      title: t("about.solutions.titreCard5"),
      description: t("about.solutions.paraphCard5"),
      bgColor: "bg-[#DBEAFF]",
      bgIcon: "bg-blue-primary",
    },

    {
      icon: "/assets/images/vecteurs/secure-svgrepo-com.svg",
      title: t("about.solutions.titreCard6"),
      description: t("about.solutions.paraphCard6"),
      bgColor: "bg-[#DBEAFF]",
      bgIcon: "bg-blue-primary",
    },
  ];

  return (
    <section>
      <div
        id="container"
        className="flex flex-col items-center justify-center py-10"
      >
        <h1 className="text-blue-primary font-bold text-2xl xl:text-3xl">
          {t("about.solutions.titre")}
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 px-5 lg:px-16 py-12">
          {items.map((items, index) => (
            <div key={index} className="h-full ">
              <div
                className={`h-full ${items.bgColor} w-full p-8
                  rounded-2xl shadow-md shadow-gray-400 flex flex-col px-[10px] 
                  lg:px-[4px] mx-auto items-center`}
              >
                <div
                  className=" flex gap-2 items-start
                    "
                >
                  <div className="  ">
                    <div
                      className={`${items.bgIcon} rounded-lg flex justify-center items-center 
                      h-12 w-12 `}
                    >
                      <img
                        src={items.icon}
                        alt={items.title}
                        className="w-8 "
                      />
                    </div>
                  </div>
                  <div>
                    <h2
                      className={` text-[18px] font-bold  text-blue-primary  `}
                    >
                      {items.title}
                    </h2>
                    <p className={` text-[16px]   `}>{items.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
